import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

type ProductReferenceId =
	| "free"
	| "starter"
	| "pro"
	| "enterprise"
	| "lifetime";

export function usePlanData() {
	const t = useTranslations();

	const planData: Record<
		ProductReferenceId,
		{
			title: string;
			features: ReactNode[];
		}
	> = {
		free: {
			title: t("pricing.products.free.title"),
			features: [
				t("pricing.products.free.features.feature1"),
				t("pricing.products.free.features.feature2"),
				t("pricing.products.free.features.feature3"),
			],
		},
		starter: {
			title: t("pricing.products.starter.title"),
			features: [
				t("pricing.products.starter.features.feature1"),
				t("pricing.products.starter.features.feature2"),
				t("pricing.products.starter.features.feature3"),
				t("pricing.products.starter.features.feature4"),
			],
		},
		pro: {
			title: t("pricing.products.pro.title"),
			features: [
				t("pricing.products.pro.features.feature1"),
				t("pricing.products.pro.features.feature2"),
				t("pricing.products.pro.features.feature3"),
				t("pricing.products.pro.features.feature4"),
			],
		},
		enterprise: {
			title: t("pricing.products.enterprise.title"),
			features: [
				t("pricing.products.enterprise.features.unlimitedProjects"),
				t("pricing.products.enterprise.features.enterpriseSupport"),
			],
		},
		lifetime: {
			title: t("pricing.products.lifetime.title"),
			features: [
				t("pricing.products.lifetime.features.noRecurringCosts"),
				t("pricing.products.lifetime.features.extendSupport"),
			],
		},
	};

	return { planData };
}
